const VideoPlayer = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.videoEL = document.getElementsByClassName("js-video-wrapper");
    }

    const getYouTubeThumb = (id) => {
        const thumb = "<img src='https://i.ytimg.com/vi/ID/hqdefault.jpg'>";
        const play = "<div class='play'></div>";
        return thumb.replace("ID", id) + play;
    }

    const getVimeoThumb = (el, id, cb) => {
        return new Promise(resolve => {
            const request = new XMLHttpRequest();
            const url = "https://vimeo.com/api/v2/video/" + id + ".json";
            request.open("GET", url, true);
            request.onload = function() {
                if (request.status >= 200 && request.status < 400) {
                    const data = JSON.parse(request.responseText);
                    const thumbnail = data[0].thumbnail_large;
                    cb(el, data);
                    resolve(data);
                }
            }
            request.send();
        });
    }

    const showThumb = (el, data) => {
        const play = document.createElement("div");
        play.classList.add("play");
        const img = new Image();
        img.src = data[0].thumbnail_large;
        const thumbnailContainer = el;
        thumbnailContainer.appendChild(img);
        thumbnailContainer.appendChild(play);
        thumbnailContainer.addEventListener("click", function() {
            setIFrame(el);
        });
    }

    const setIFrame = (el) => {
        const iframe = document.createElement("iframe");
        let embed;
        if (el.className === "vimeo-player") {
            embed = "https://player.vimeo.com/video/ID?autoplay=1&loop=1&autopause=0&background=1&muted=1";
            iframe.setAttribute("height", el.clientHeight);
            iframe.setAttribute("width", el.clientWidth);
        } else {
            embed = "https://www.youtube.com/embed/ID?autoplay=1&mute=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&controls=0&loop=1&disablekb=1&rel=0";
            iframe.setAttribute("height", el.clientHeight);
            iframe.setAttribute("width", el.clientWidth);
        }
        iframe.setAttribute("src", embed.replace("ID", el.dataset.id));
        iframe.setAttribute("height", el.clientHeight);
        iframe.setAttribute("width", el.clientWidth);
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        iframe.setAttribute("allow", "autoplay");
        el.parentNode.replaceChild(iframe, el);
    }

    const videoIframe = async (el) => {
        const activeVideoElement = el;
        const player = el.className;

        switch (player) {
            case 'vimeo-player' :
                // await getVimeoThumb(activeVideoElement, el.dataset.id, showThumb);
                setIFrame(el);
                break;
            default:
                // const videContainer = document.createElement("div");
                // videContainer.setAttribute("data-id", activeVideoElement.dataset.id);

                if ( activeVideoElement.parentElement.classList.contains('js-video-wrapper--cover') ) {
                    activeVideoElement.innerHTML = await getYouTubeThumb(activeVideoElement.dataset.id);
                    activeVideoElement.onclick = function() { setIFrame(activeVideoElement); }
                } else {
                    activeVideoElement.onclick = setIFrame(activeVideoElement);
                }

                // activeVideoElement.appendChild(videContainer);
                break;
        }
    }

    const loadVideoIframe = async () => {
        Array.from(DOM.videoEL).forEach( (el) => {
            const videoWrapper = el.firstElementChild;
            videoIframe(videoWrapper);
        });
    }

    const init = async () => {
        cacheDOM();
        await loadVideoIframe();
    }

    return {
        init,
        videoIframe,
        setIFrame
    }
})();

export default VideoPlayer;
